export default "__VITE_ASSET__C_z9MRGH__"